import { FeatureName } from '@/enums/feature-names';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class FeatureFlagService {
    private static _featureFlags: Record<string, boolean> = {};

    private constructor() {}

    public static async init(): Promise<void> {
        const featureFlagsResponse: Response = await fetch('/feature-flags.json');

        this._featureFlags = await featureFlagsResponse.json();
    }

    public static isFeatureFlagActive(featureFlag: FeatureName): boolean {
        return this._featureFlags[featureFlag];
    }
}

export { FeatureFlagService };
